import { DocumentData, QueryDocumentSnapshot } from 'firebase/firestore';
import { IHistoryEntry } from '@leedpulse-monorepo/interfaces';
import { HistoryEntryName, HistoryEntryType } from '@leedpulse-monorepo/enums';

export default class UserHistory implements IHistoryEntry {
  timestamp: number;
  /** Entry type: email, sms, push */
  type: HistoryEntryType;
  /** Specific event name, e.g. email_welcome_leedflow */
  name: HistoryEntryName;

  // Custom props
  external_id?: string;
  adminUid?: string;

  constructor(
    timestamp: number,
    type: HistoryEntryType,
    name: HistoryEntryName,
    external_id: string | undefined = undefined,
    adminUid: string | undefined = undefined,
  ) {
    this.timestamp = timestamp;
    this.type = type;
    this.name = name;
    this.external_id = external_id;
    this.adminUid = adminUid;
  }

  get getTimestamp(): number {
    return this.timestamp;
  }

  get getType(): HistoryEntryType {
    return this.type;
  }

  get getName(): HistoryEntryName {
    return this.name;
  }

  get getExternalId(): string | undefined {
    return this.external_id;
  }

  get getAdminUid(): string | undefined {
    return this.adminUid;
  }

  public copyWith({
    timestamp,
    type,
    name,
    external_id,
    adminUid,
  }: {
    timestamp?: number;
    type?: HistoryEntryType;
    name?: HistoryEntryName;
    external_id?: string | undefined;
    adminUid?: string | undefined;
  }): UserHistory {
    return new UserHistory(
      timestamp ?? this.timestamp,
      type ?? this.type,
      name ?? this.name,
      external_id ?? this.external_id,
      adminUid ?? this.adminUid,
    );
  }

  static fromFirestore(
    data: QueryDocumentSnapshot<DocumentData, DocumentData>
  ): UserHistory {
    const historyData = data.data();
    return new UserHistory(
      historyData.timestamp,
      historyData.type,
      historyData.name,
      historyData.external_id,
      historyData.adminUid,
    );
  }

  toFirestorePatch(): Record<string, string | undefined | number | HistoryEntryType | HistoryEntryName> {
    return {
      timestamp: this.timestamp,
      type: this.type,
      name: this.name,
      external_id: this.external_id,
      adminUid: this.adminUid,
    };
  }
}
